import { createStore } from 'vuex'

const store = createStore({
  state: {
    userinfo: {} as any,
    slidebardata: [],
    currentuserinfo: {} as any,
    shelfmiceidinfo: {} as any,
    shelfmicelist: [] as Array<string>,
    taskOfTypeInfo: {} as any,
    houseidleeder: {} as any,
    cageColorInfo: {} as any,
    regioninfo: {} as any,
    selectedRegion: {} as any,
    notificationVersion: 0
    // strainidstrainlist:{} as any
  },
  mutations: {
    reloads(state, data) {
      state.userinfo = data.userinfo
      state.slidebardata = data.slidebardata
      state.currentuserinfo = data.currentuserinfo
      state.shelfmiceidinfo = data.shelfmiceidinfo
      state.taskOfTypeInfo = data.taskOfTypeInfo
      state.houseidleeder = data.houseidleeder
      state.cageColorInfo = data.cageColorInfo
      state.regioninfo = data.regioninfo
      state.selectedRegion = data.selectedRegion
      // state.strainidstrainlist=data.strainidstrainlist
    },
    setuserinfo(state, data) {
      state.userinfo = data
    },
    setslidedata(state, data) {
      state.slidebardata = data
    },
    setcurrentuserinfo(state, data) {
      state.currentuserinfo = data
    },
    savemiceinfo(state, data) {
      state.shelfmiceidinfo = data
    },
    savemicelist(state, data) {
      state.shelfmicelist = data
    },
    savetaskOfTypeInfo(state, data) {
      state.taskOfTypeInfo = data
    },
    refreshNotifications(state) {
      state.notificationVersion += 1
    },
    savehouseleeder(state, data) {
      state.houseidleeder = data
    },
    savecageColorInfo(state, data) {
      state.cageColorInfo = data
    },
    saveregioninfo(state, data) {
      state.regioninfo = data
    },
    setselectedRegion(state, data) {
      state.selectedRegion = data
    },
    // setstrainidnamelist(state,data){
    //   state.strainidstrainlist=data
    // }
  },
  actions: {
  },
  modules: {
  }
})
export default store
